var map = {
	"./calendar/calendar.module": [
		"./src/app/calendar/calendar.module.ts",
		"calendar-calendar-module"
	],
	"./cards/cards.module": [
		"./src/app/cards/cards.module.ts",
		"default~cards-cards-module~charts-charts-module",
		"common",
		"cards-cards-module"
	],
	"./charts/charts.module": [
		"./src/app/charts/charts.module.ts",
		"default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"default~cards-cards-module~charts-charts-module",
		"default~charts-charts-module~pages-content-pages-content-pages-module",
		"common",
		"charts-charts-module"
	],
	"./chat-ngrx/chat-ngrx.module": [
		"./src/app/chat-ngrx/chat-ngrx.module.ts",
		"default~chat-chat-module~chat-ngrx-chat-ngrx-module~player-player-module",
		"common",
		"chat-ngrx-chat-ngrx-module"
	],
	"./chat/chat.module": [
		"./src/app/chat/chat.module.ts",
		"default~chat-chat-module~chat-ngrx-chat-ngrx-module~player-player-module",
		"common",
		"chat-chat-module"
	],
	"./color-palette/color-palette.module": [
		"./src/app/color-palette/color-palette.module.ts",
		"color-palette-color-palette-module"
	],
	"./components/ui-components.module": [
		"./src/app/components/ui-components.module.ts",
		"default~components-ui-components-module~inbox-inbox-module",
		"default~components-ui-components-module~ui-kit-ui-kit-module",
		"common",
		"components-ui-components-module"
	],
	"./dashboard/dashboard.module": [
		"./src/app/dashboard/dashboard.module.ts",
		"default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"common",
		"dashboard-dashboard-module"
	],
	"./data-tables/data-tables.module": [
		"./src/app/data-tables/data-tables.module.ts",
		"data-tables-data-tables-module"
	],
	"./forms/forms.module": [
		"./src/app/forms/forms.module.ts",
		"default~forms-forms-module~ngx-wizard-ngx-wizard-module",
		"common",
		"forms-forms-module"
	],
	"./inbox/inbox.module": [
		"./src/app/inbox/inbox.module.ts",
		"default~components-ui-components-module~inbox-inbox-module",
		"common",
		"inbox-inbox-module"
	],
	"./maps/maps.module": [
		"./src/app/maps/maps.module.ts",
		"maps-maps-module"
	],
	"./ngx-wizard/ngx-wizard.module": [
		"./src/app/forms/ngx-wizard/ngx-wizard.module.ts",
		"default~forms-forms-module~ngx-wizard-ngx-wizard-module",
		"common"
	],
	"./pages/annonce-details/annonce-details.module": [
		"./src/app/pages/annonce-details/annonce-details.module.ts",
		"pages-annonce-details-annonce-details-module"
	],
	"./pages/content-pages/content-pages.module": [
		"./src/app/pages/content-pages/content-pages.module.ts",
		"default~charts-charts-module~pages-content-pages-content-pages-module",
		"common",
		"pages-content-pages-content-pages-module"
	],
	"./pages/full-pages/full-pages.module": [
		"./src/app/pages/full-pages/full-pages.module.ts",
		"default~charts-charts-module~dashboard-dashboard-module~pages-full-pages-full-pages-module",
		"common",
		"pages-full-pages-full-pages-module"
	],
	"./player/player.module": [
		"./src/app/player/player.module.ts",
		"default~chat-chat-module~chat-ngrx-chat-ngrx-module~player-player-module",
		"common",
		"player-player-module"
	],
	"./tables/tables.module": [
		"./src/app/tables/tables.module.ts",
		"common",
		"tables-tables-module"
	],
	"./taskboard-ngrx/taskboard-ngrx.module": [
		"./src/app/taskboard-ngrx/taskboard-ngrx.module.ts",
		"taskboard-ngrx-taskboard-ngrx-module"
	],
	"./taskboard/taskboard.module": [
		"./src/app/taskboard/taskboard.module.ts",
		"taskboard-taskboard-module"
	],
	"./ui-kit/ui-kit.module": [
		"./src/app/ui-kit/ui-kit.module.ts",
		"default~components-ui-components-module~ui-kit-ui-kit-module",
		"common",
		"ui-kit-ui-kit-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;